import { EmptyWidget, EmptyWidgetProps } from '../EmptyWidget/EmptyWidget';

export interface RetryApiAlertProps extends Omit<EmptyWidgetProps, 'title'> {
  title?: string;
  trackingProps?: object;
}

export function RetryApiAlert({
  title = 'Sorry, Something Went Wrong!',
  dataId = '',
  subTitle,
  secondaryCTAProps,
  primaryCTAProps,
  className,
  trackingProps = {},
  compact = false
}: RetryApiAlertProps) {
  return (
    <EmptyWidget
      dataId={dataId}
      icon='error-outline'
      iconClass='text-error'
      iconContainerBgClass='bg-error-faded'
      className={className}
      title={title}
      subTitle={subTitle}
      trackingProps={{
        ...trackingProps,
        context: 'API_FAILURE_RETRY'
      }}
      secondaryCTAProps={
        secondaryCTAProps ? { children: 'Try Again', ...secondaryCTAProps } : undefined
      }
      primaryCTAProps={primaryCTAProps}
      compact={compact}
    />
  );
}
